import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useAuth } from 'react-oidc-context';

import api from 'api/api';

import { FileResponse } from './types';

const fetchFiles = async () => {
  const { data } = await api.get(`/files`);

  return data;
};

const useFiles = () => {
  const auth = useAuth();
  return useQuery<FileResponse[], AxiosError>({ queryKey: ['files'], queryFn: fetchFiles, enabled: auth.isAuthenticated });
};

export default useFiles;
